import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Table, Image, Button } from "react-bootstrap";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import AddReferreePopup from "../../superAdminAllComponent/superAdminRefferalsCode/referralsPopup/AddReferreePopup";

function salesRepresentativedashboard(props) {
  const RenderTableBody = () => {
    return (
      <React.Fragment>
        <TableBody />
      </React.Fragment>
    );
  };
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Sales Representative Dashboard
                  <br />
                </div>
                <div className="col-6 text-right">
                  <AddReferreePopup />
                </div>
              </div>
              <div className="row">
                <div className="col-4 d-flex">
                  <Image
                    //   onClick={() =>
                    //     setState({
                    //       ...state,
                    //       showSearch: !state.showSearch,
                    //     })
                    //   }
                    alt="filter"
                    title="filter"
                    width="80px"
                    src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                  />
                  <div
                    className="f10-400"
                    align="center"
                    // onClick={() => showFilter(!filter)}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                      width="80px"
                    />
                    <br />
                  </div>
                  <div
                    className="f10-400"
                    align="center"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    // onClick={props.handleClick}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/sortbtn.svg")}
                      width="80px"
                    />
                    <br />
                  </div>
                  <div className="f10-400" align="center">
                    <img
                      src={require("../../../../assets/images/iconButton/downloadbtn.svg")}
                      width="80px"
                      alt="icon"
                    />
                    <br />
                  </div>
                </div>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                    {/* <SelectFilter onDateChange={onDateChangeHandler} /> */}
                  </div>
                </div>
                <div className="col-2"></div>
              </div>
              <hr />
              <div>
                <div
                  className="d-flex  mt-3 mb-3"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="mr-3 d-flex">
                    <SelectFilter onDateChange={() => {}} />
                  </div>
                  <RightSideCountTop
                    content={[
                      {
                        name: "Inactive Events",
                        // loader: props.auth.secondary_loader,
                        value: 0,
                        backgroundColor: "#FFEDE9",
                        color: "#EE3A23",
                      },
                      {
                        name: "Active Events",
                        //  loader: props.auth.secondary_loader,
                        value: 0,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      },
                      {
                        name: "Total Events",
                        //  loader: props.auth.secondary_loader,
                        value: 0,
                        backgroundColor: "#D8F3F4",
                        color: "#138B90",
                      },
                    ]}
                  />
                </div>
              </div>
              <div className="super-admin-rating-review-tab super-admin-issues-open-users-tab">
                <div className="ml-4">
                  <div className="d-flex align-items-center">
                    <Button
                      variant="link"
                      className={`px-0 mr-4 text-grayLink f12-500 active`}
                    >
                      Active
                    </Button>
                    <Button
                      variant="link"
                      className={`px-0 mr-4 text-grayLink f12-500`}
                    >
                      Inactive
                    </Button>
                    <Button
                      variant="link"
                      className={`px-0 mr-4 text-grayLink f12-500`}
                    >
                      All
                    </Button>
                  </div>
                </div>
              </div>
              <hr />
              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                {/* <div className="col-12 p-0 user-table-reusable-superadmin table-responsive"> */}
                <Table className="">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: "15%" }} className="f12-400">
                        ID
                      </td>
                      <td style={{ width: "15%" }} className="f12-400">
                        Referral Code
                      </td>
                      <td style={{ width: "8%" }} className="f12-400">
                        Referrer <br />
                        Type
                      </td>
                      <td style={{ width: "8%" }} className="f12-400">
                        Name
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        conatct
                        <br />
                        Number
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Position <br />/ Designation*
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Validity Start/ <br /> DOJ / DOP*
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Status
                      </td>
                      <td style={{ width: "14%" }} className="f12-400">
                        Action
                      </td>
                    </tr>
                  </thead>
                  {RenderTableBody()}
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const TableBody = (props) => {
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = () => setTrDetail(!TrDetail);
  return (
    <tbody className="w-100 super-admin-all-vendor-main-table-body">
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr className="sd_body_table-row" onClick={showTr}>
                <td style={{ width: "15%" }}>
                  <div>
                    <h5 className="font_16_m mt-3">#1234</h5>
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <h3 className="font_20_m">Sp0011</h3>
                </td>
                <td style={{ width: "8%" }}>
                  <div className="f12-500">Sales</div>
                </td>
                <td style={{ width: "8%" }}>
                  <div className="f12-500">Miles Morales</div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">91919199191</div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">sales intern</div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="font_18_b">21 Aug 2021</div>
                </td>
                <td style={{ width: "10%", paddingLeft: "1.5rem" }}>Active</td>
                <td style={{ width: "14%" }}>
                  <button
                    // onClick={props.onClickVendorId}
                    className="enViewDashboard btn btn-outline-danger d-flex align-items-center"
                  >
                    <Image
                      src={require("../../../../assets/images/ActionImages/image/onboarding.svg")}
                      alt="View"
                      title="View"
                      fluid
                      className="mr-2"
                      width="20px"
                    />
                  </button>
                </td>
              </tr>
              {TrDetail && (
                <>
                  <tr className="sd_accordion_body">
                    <td style={{ width: "18%" }}>
                      <div className="f12-400">Email ID</div>
                      <div className="f12-400">mail@gmail.com</div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="f12-400">Grade / Band</div>
                      <div className="f12-400 mt-2">-</div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="f12-400">City/Location</div>
                      <div className="f12-400 mt-2">pune</div>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

export default salesRepresentativedashboard;
